import { Container, Heading, Paragraph } from '@purpur/library';
import styled from 'styled-components';

import { purpurFocus } from '@telialt/common-theme/src/mixins';
import {
    getPurpurBorder,
    getPurpurColor,
    getPurpurSpacing,
    purpurMedia,
} from '@telialt/common-theme/src/purpurSelectors';

export const AppPromotionSection = styled.section`
    background-color: ${getPurpurColor('backgroundPrimaryNegative')};
    padding-top: ${getPurpurSpacing('400')};
    padding-bottom: ${getPurpurSpacing('400')};
`;

export const AppPromotionContainer = styled(Container)`
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('300')};

    ${purpurMedia('md')`
        flex-direction: row;
    `}
    ${purpurMedia('lg')`
        gap: ${getPurpurSpacing('400')};
    `}
`;

export const AppPromotionContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('100')};
    margin-right: auto;
`;

export const AppPromotionTitle = styled(Heading).attrs({ tag: 'h2', variant: 'title-200', negative: true })``;

export const AppPromotionDescription = styled(Paragraph).attrs({ variant: 'paragraph-100', negative: true })``;

export const StoreButtonsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('200')};
`;

export const StoreButtonLink = styled.a`
    line-height: 0;
    ${purpurFocus()}
`;

export const QrCodeImage = styled.img.attrs({ width: 112, height: 112 })`
    border-radius: ${getPurpurBorder('radiusMd')};
    border: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('borderMedium')};
`;

export const EmptyGap = styled.div.attrs({ 'aria-hidden': true })`
    display: none;

    ${purpurMedia('md')`
        display: block;
        width: 2.5625rem;
    `}
    ${purpurMedia('lg')`
        width: 5.625rem;
    `}
`;
